import { Color, Container, FillGradient, Sprite, Text, TextStyle } from "pixi.js";

// import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { Group, Tween } from "tweedle.js";
import { languageGlobal } from "../config/GlobalVariableConfig";
import { getFontConfig } from "../config/introTextConfig";

declare const window: any;
const translationManager = window.hacksawCasino.Translation;

// const headingTextStyle = new TextStyle({
//     fontFamily: "8-bit_quest_intro_1",
//     // fill: "#ffeeb3",
//     // fontWeight: "bold",
//     fontSize: 45,
//     // // stroke: {
//     // //     color: "#000000",
//     // //     width: 3,
//     // // },
//     // dropShadow:
//     // {
//     //     blur: 8,
//     //     color: "#000000",
//     //     distance: 7,
//     // },
//     // letterSpacing: 2

// });





// const VolatilityTextStyle = new TextStyle({
//     fontFamily: "8-bit_quest_intro_2",
//     // fill: "#f7e6c8",
//     fontSize: 35,
//     // align: "center",
//     // letterSpacing : 1.5,
//     // stroke: {
//     //     color: "#000000",
//     //     width: 3,
//     // },
//     // dropShadow:
//     // {
//     //     blur: 3,
//     //     color: "#320900",
//     //     distance: 5,
//     // },
//     // trim: true,
// });




export class IntroScene extends Container {
    // public loaderBar: Container = new Container();

    private allTextContainer: Container = new Container();

    private volatilityContainer: Container = new Container();
    private continueButtonContainer: Container = new Container();

    private tileContainer1 = new Container();
    private tileContainer2 = new Container();
    private tileContainer3 = new Container();
    private tileIndex: number = 0;
    private animationInterval: any;

    private tweenGroupForTiles: Group = new Group();
    private tweenGroupForScale: Group = new Group();
    private tweenGroupForBreath: Group = new Group();

    private logo: Spine;
    // private logo: Sprite;
    private screenWidth: number = 0;
    private screenHeight: number = 0;

    constructor() {
        super();

        this.eventMode = 'static';
        this.interactive = true;

        // this.addChild(this.allTextContainer);


        console.log("languageGlobal", languageGlobal)


        // switch (languageGlobal) {
        //     case "en":
        //         descriptionTextStyle.fontFamily = "nokiafc22";
        //         break;

        //     default:
        //         descriptionTextStyle.fontFamily = "\"Comic Sans MS\", cursive, sans-serif";
        //         break;
        // }

        document.addEventListener("visibilitychange", this.handleVisibilityChange);


    }

    override destroy(): void {
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);

        super.destroy({ children: true, texture: false });
    }

    private handleVisibilityChange = (): void => {
        if (document.hidden) {
            this.endTileAnimation(); // Pause animation
        } else {
            // Restart animation if in portrait mode
            const isLandscape = this.screenWidth > this.screenHeight;
            if (!isLandscape) {
                this.startTileAnimation();
            }
        }
    };

    private backgroundImage: Sprite;
    public async showInitLogo(screenWidth: number, screenHeight: number) {

        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;


        this.backgroundImage = Sprite.from('intro_bg');

        this.addChild(this.backgroundImage);
        this.addChild(this.allTextContainer);




        // this.logo = Sprite.from('introLogoStatic');
        // this.logo.scale = 0.5;
        // this.logo.anchor = 0.5;
        // logo.position.set(1490, 1080);
        // this.allTextContainer.addChild(logo);

        this.logo = Spine.from({
            skeleton: "introLogoSkel",
            atlas: "introLogoAtlas",
        });
        this.logo.state.setAnimation(0, "animation", true);
        // this.logo.scale = 0.75;
        this.logo.position.set(1500, 1120);
        this.allTextContainer.addChild(this.logo);

        this.setupVolatilityText();

        /*------------------------------------- */

        // this.tileContainer1.position.set(870, 1620);
        this.allTextContainer.addChild(this.tileContainer1);

        const tileImage1 = "image1";
        const headingTextVal1 = translationManager.game('intro_ticket_heading_1_uc');//"WILD LOOT";
        const descTextVal1 = translationManager.game('intro_ticket_desc_1');//"Winning symbols burst away and a random number of wilds fill the gaps on reels 2-4!";

        this.setupTile(this.tileContainer1, tileImage1, headingTextVal1, descTextVal1);

        /*------------------------------------- */

        // this.tileContainer2.position.set(1500, 1509);
        this.allTextContainer.addChild(this.tileContainer2);

        const tileImage2 = "image2";
        const headingTextVal2 = translationManager.game('intro_ticket_heading_2_uc');//"MULTIPLIER MANIA";
        const descTextVal2 = translationManager.game('intro_ticket_desc_2');//"Multipliers up to 100x may appear on wilds, boosting wins and accumulating for epic payouts!";

        this.setupTile(this.tileContainer2, tileImage2, headingTextVal2, descTextVal2);

        /*------------------------------------- */

        // this.tileContainer3.position.set(2130, 1620);
        this.allTextContainer.addChild(this.tileContainer3);

        const tileImage3 = "image3";
        const headingTextVal3 = translationManager.game('intro_ticket_heading_3_uc');//"8-BIT BONUS";
        const descTextVal3 = translationManager.game('intro_ticket_desc_3');//"Earn bigger multipliers in free spins that accumulate and persist throughout the bonus game!Earn bigger multipliers in free spins that accumulate and persist throughout the bonus game!";

        this.setupTile(this.tileContainer3, tileImage3, headingTextVal3, descTextVal3);

        /*------------------------------------- */

        this.setupContinueButton();

        let currentVal: number = .75;
        let targetVal: number = 1;
        new Tween({ x: currentVal }, this.tweenGroupForScale)
            .to({ x: targetVal }, 300)
            .onComplete(() => {
                this.tweenGroupForScale.removeAll();
            })
            .onUpdate((object) => {
                currentVal = object.x; // Update currentVal with the tweened value
                this.resize(this.screenWidth, this.screenHeight, currentVal);
                // this.tileContainer1.scale = currentVal;
                // this.tileContainer2.scale = currentVal;
                // this.tileContainer3.scale = currentVal;

                // this.logo.scale = currentVal;
                // this.lodo.scale = currentVal;
            })
            .start();



        // this.resize(this.screenWidth, this.screenHeight);

    }


    private setupTile(tileContainer1: Container, tileImageName: string, headingTextVal: string, descTextVal: string): void {


        const tileBase1: Sprite = Sprite.from("textBase");
        tileBase1.anchor = 0.5;
        tileBase1.scale = 1;
        tileContainer1.addChild(tileBase1);


        let imageScale = 1;
        let imageY = 0;
        let headingY = -155;
        let descY = 140;
        // if (tileImageName == "image1") {
        //     imageScale = 0.75;
        // }
        // else if (tileImageName == "image2") {
        //     imageScale = 0.9;
        //     imageY = -65;
        // }
        // else if (tileImageName == "image3") {
        //     descY = 115;
        // }
        // if (tileImageName == "image3") {
        //     imageY = -120;
        //     imageScale = 0.9;
        // }

        const tileImage: Sprite = Sprite.from(tileImageName);
        tileImage.anchor = 0.5;
        tileImage.scale = imageScale;
        tileImage.position.set(0, imageY);
        tileContainer1.addChild(tileImage);

        const {
            fontFamily: fontFamilyHeading,
            fontWeight: fontWeightHeading,
            fontSize: fontSizeHeading,
            letterSpacing: letterSpacingHeading,
            lineHeight: lineHeightHeading
        } = getFontConfig(languageGlobal, "heading");


        // const fill = new FillGradient(0, 0, 0, 32 * 1 * 3);
        // const colors = ["#fff08d", "#ffab34"].map((color) => Color.shared.setValue(color).toNumber());

        // colors.forEach((number, index) => {
        //     const ratio = index / colors.length;

        //     fill.addColorStop(ratio, number);
        // });

        const headingText = new Text({
            text: headingTextVal,
            style: {
                fontFamily: fontFamilyHeading,
                // fill: { fill },
                fontWeight: fontWeightHeading,
                fontSize: fontSizeHeading,
                stroke: {
                    color: "#06044a",
                    width: 4,
                },
                dropShadow:
                {
                    // blur: 5,
                    color: "#0090ff",
                    distance: 3,
                },
                letterSpacing: letterSpacingHeading,//1,
                wordWrap: true,
                wordWrapWidth: 420,
                align: "center",
                lineHeight: lineHeightHeading,//50
                breakWords: true,

            }
        });

        headingText.anchor.set(0.5, 0.5);
        headingText.position.set(0, headingY);
        tileContainer1.addChild(headingText);


        // Create gradient based on actual text height AFTER scaling
        const fill = new FillGradient(0, 0, 0, headingText.height);
        const colors = ["#ffffff"].map((color) =>
            Color.shared.setValue(color).toNumber()
        );

        colors.forEach((number, index) => {
            const ratio = index / colors.length;
            fill.addColorStop(ratio, number);
        });

        // Apply the gradient fill to the text
        headingText.style.fill = fill;



        const {
            fontFamily: fontFamilyDesc,
            fontWeight: fontWeightDesc,
            fontSize: fontSizeDesc,
            letterSpacing: letterSpacingDesc,
            lineHeight: lineHeightDesc
        } = getFontConfig(languageGlobal, "description");


        const descriptionTextStyle = new TextStyle({
            fontFamily: fontFamilyDesc,
            fill: "#cbdcf7",
            fontWeight: fontWeightDesc,
            fontSize: fontSizeDesc,

            align: "center",
            wordWrap: true,
            // trim: true,
            letterSpacing: letterSpacingDesc,
            ...(lineHeightDesc != null && { lineHeight: lineHeightDesc }),
            breakWords: true,

        });

        const descriptionText = new Text({
            text: descTextVal,
            style: descriptionTextStyle
        });

        // descriptionText.style.wordWrap = true;
        descriptionText.style.wordWrapWidth = 425;
        // descriptionText.style.lineHeight = 500;


        descriptionText.anchor.set(0.5, 0.5);
        descriptionText.position.set(0, descY);
        tileContainer1.addChild(descriptionText);


    }

    public update() {

        this.tweenGroupForScale.update();
        this.tweenGroupForTiles.update();
        this.tweenGroupForBreath.update();
    }



    private setupVolatilityText(): void {




        const volatilityBase: Sprite = Sprite.from('volatilityBase');
        volatilityBase.anchor = 0.5;
        volatilityBase.scale = 1.5;
        this.volatilityContainer.addChild(volatilityBase);


        this.volatilityContainer.position.set(1500, 1210);
        this.volatilityContainer.scale.set(0.7);
        this.allTextContainer.addChild(this.volatilityContainer);

        // const fill = new FillGradient(0, 0, 0, 32 * 1 * 3);
        // const colors = ["#ffffff", "#ecc8ff", "#ea77ff"].map((color) => Color.shared.setValue(color).toNumber());

        // colors.forEach((number, index) => {
        //     const ratio = index / colors.length;

        //     fill.addColorStop(ratio, number);
        // });

        const {
            fontFamily: fontFamilyVal,
            fontWeight: fontWeightVal,
            fontSize: fontSizeVal,
        } = getFontConfig(languageGlobal, "volatility");


        const text = new Text({
            text: translationManager.game('intro_volatility_uc'),//'VOLATILITY',
            style: {
                fontFamily: fontFamilyVal,
                // fill: { fill },
                stroke: {
                    color: "#2409b7",
                    width: 2,
                },
                dropShadow:
                {
                    blur: 5,
                    color: "#080346",
                    distance: 3,
                },
                fontSize: fontSizeVal,
                fontWeight: fontWeightVal,
            }
        });



        text.anchor.set(0.5, 0.5);
        text.position.set(-200, 0);

        const textScale = Math.min(500 / text.width, 1);
        text.scale = textScale;


        // Create gradient based on actual text height AFTER scaling
        const fill = new FillGradient(0, 0, 0, text.height);
        const colors = ["#d4f3ff", "#a0ddff", "#52c3ff"].map((color) =>
            Color.shared.setValue(color).toNumber()
        );

        colors.forEach((number, index) => {
            const ratio = index / colors.length;
            fill.addColorStop(ratio, number);
        });

        // Apply the gradient fill to the text
        text.style.fill = fill;

        this.volatilityContainer.addChild(text);

        // volatilityBase.position.set(20 + text.width / 2, -2);


        // Define the volatility value
        const volatilityVal = 4; // Example value

        // Adding 5 vol images in a line
        const volSpacing = 60; // Space between each vol
        const volStartX = -100 + text.width / 2; // Starting position to center vols

        for (let i = 0; i < 5; i++) {
            const volTexture = i < volatilityVal ? 'volatilityOn' : 'volatilityOff';
            const vol = Sprite.from(volTexture);
            vol.scale = 1.5;
            vol.anchor.set(0.5);
            vol.position.set(volStartX + i * volSpacing, 0); // Adjust Y position as needed
            this.volatilityContainer.addChild(vol);
        }

    }

    private setupContinueButton(): void {


        this.continueButtonContainer = new Container();
        // this.continueButtonContainer.cursor = 'pointer';
        // this.continueButtonContainer.eventMode = 'static';
        // this.continueButtonContainer.interactive = true;

        const continueButtonBase: Sprite = Sprite.from('continueBase');
        continueButtonBase.anchor = 0.5;
        continueButtonBase.scale.set(0.8, 0.9);
        continueButtonBase.position.set(0, 0);

        // // this.continueButtonContainer.pivot.set(this.continueButtonContainer.width / 2, this.continueButtonContainer.height / 2)
        this.continueButtonContainer.addChild(continueButtonBase);

        // this.continueButtonContainer.position.set(1500, 2300);
        this.allTextContainer.addChild(this.continueButtonContainer);

        // const fill = new FillGradient(0, 0, 0, 32 * 1 * 3);
        // const colors = ["#ffffff", "#ecc8ff", "#ea77ff"].map((color) => Color.shared.setValue(color).toNumber());

        // colors.forEach((number, index) => {
        //     const ratio = index / colors.length;

        //     fill.addColorStop(ratio, number);
        // });

        const {
            fontFamily: fontFamilyVal,
            fontWeight: fontWeightVal,
            fontSize: fontSizeVal,
        } = getFontConfig(languageGlobal, "continue");


        const text = new Text({
            text: translationManager.game('intro_continue_uc'),//'Click to Continue',
            style: {
                fontFamily: fontFamilyVal,
                // fill: { fill },
                stroke: {
                    color: "#2409b7",
                    width: 2,
                },
                dropShadow:
                {
                    // blur: 1,
                    color: "#3f3b71",
                    distance: 3,
                    // width: 12,
                },
                fontWeight: fontWeightVal,
                fontSize: fontSizeVal,
            }
        });


        text.anchor = 0.5;

        const currentScale = Math.min(600 / text.width, 1);
        text.scale = currentScale;

        // Create gradient based on actual text height AFTER scaling
        const fill = new FillGradient(0, 0, 0, text.height);
        const colors = ["#d4f3ff", "#a0ddff", "#52c3ff"].map((color) =>
            Color.shared.setValue(color).toNumber()
        );

        colors.forEach((number, index) => {
            const ratio = index / colors.length;
            fill.addColorStop(ratio, number);
        });

        // Apply the gradient fill to the text
        text.style.fill = fill;

        text.position.set(0, -5);
        // text.position.set(continueButtonBase.width / 2, continueButtonBase.height / 2);

        this.continueButtonContainer.addChild(text);


        const tweenBreath = new Tween(text.scale, this.tweenGroupForBreath)
            .to({ x: currentScale * 1.03, y: currentScale * 1.03 }, 1000) // Scale up
            .yoyo(true) // Automatically reverses the tween
            .repeat(Infinity) // Infinite loop
            .onComplete(() => {
                this.tweenGroupForBreath.remove(tweenBreath);
            })
            .start();

        // this.continueButtonContainer.on('pointerover', () => {
        //     this.continueButtonContainer.tint = "#ffaa00";
        // });

        // this.continueButtonContainer.on('pointerout', () => {
        //     this.continueButtonContainer.tint = "#ffffff";
        // });

    }

    public resize(screenWidth: number, screenHeight: number, zoomFactor?: number): void {

        // console.log(`resize screenWidth${screenWidth} screenHeight ${screenHeight}`);

        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        const isLandscape = screenWidth > screenHeight;

        let portraitscale;
        if (!isLandscape) {
            this.startTileAnimation();
            portraitscale = 1.75;

            this.logo.position.set(1500, 1120);

            this.continueButtonContainer.scale = 1;
            this.continueButtonContainer.position.set(1500, 1975);

            this.volatilityContainer.position.set(1500, 1310);
            this.tileContainer1.scale.set(1);
            this.tileContainer2.scale.set(1);
            this.tileContainer3.scale.set(1);

        } else {
            this.landscapeTilePositions();
            this.endTileAnimation();

            portraitscale = 1;

            this.logo.position.set(1500, 1120);

            this.continueButtonContainer.scale = 1;
            this.continueButtonContainer.position.set(1500, 1980);

            this.volatilityContainer.position.set(1500, 1300);

        }


        const scale = portraitscale * (zoomFactor ? zoomFactor : 1) * Math.min(screenWidth / (isLandscape ? 1920 : 1080), screenHeight / (isLandscape ? 1080 : 1920));
        let bgScale;
        const BG_SCALE_FACTOR = Math.max(screenWidth / 1920, screenHeight / 1920);

        this.allTextContainer.scale.set(scale, scale);
        const xPos = (3000 * scale - this.screenWidth) / 2;
        const yPos = (3000 * scale - this.screenHeight) / 2;
        this.allTextContainer.x = -xPos;
        this.allTextContainer.y = -yPos;

        bgScale = Math.max(scale, BG_SCALE_FACTOR);
        this.backgroundImage.scale.set(bgScale, bgScale)
        const bgXPos = (1920 * bgScale - screenWidth) / 2;
        const bgYPos = (1920 * bgScale - screenHeight) / 2;
        this.backgroundImage.position.set(-bgXPos, -bgYPos);





    }

    public endTileAnimation(): void {
        clearInterval(this.animationInterval);
        this.isAnimatingTiles = false;
    }

    private landscapeTilePositions(): void {

        // this.tileIndex = 0;
        clearInterval(this.animationInterval);

        // Cancel any active tweens (assuming Tween.js has a way to cancel)
        this.tweenGroupForTiles.removeAll();

        this.tileContainer1.scale.set(1);
        this.tileContainer2.scale.set(1);
        this.tileContainer3.scale.set(1);
        this.tileContainer1.position.set(870, 1600);
        this.tileContainer2.position.set(1500, 1600); // Place off-screen to the right
        this.tileContainer3.position.set(2130, 1600); // Place off-screen to the right
    }

    private isAnimatingTiles = false;

    private startTileAnimation(): void {
        if (this.isAnimatingTiles) return;
        this.isAnimatingTiles = true;

        this.resetTilePositions();
        clearInterval(this.animationInterval);

        this.animationInterval = setInterval(() => {
            this.cycleTiles();
        }, 3000);
    }

    private resetTilePositions(): void {
        this.tileContainer1.position.set(1500, 1650);
        this.tileContainer2.position.set(3000, 1650); // Place off-screen to the right
        this.tileContainer3.position.set(3000, 1650); // Place off-screen to the right
        this.tileIndex = 0;
        clearInterval(this.animationInterval);
    }

    private cycleTiles(): void {
        const currentTile = [this.tileContainer1, this.tileContainer2, this.tileContainer3][this.tileIndex];
        const nextTile = [this.tileContainer1, this.tileContainer2, this.tileContainer3][(this.tileIndex + 1) % 3];

        new Tween(currentTile.position, this.tweenGroupForTiles)
            .to({ x: 0 }, 500)
            .start();

        new Tween(nextTile.position, this.tweenGroupForTiles)
            .to({ x: 1500 }, 500)
            .onComplete(() => {
                // Move currentTile to the far right after it exits the screen
                currentTile.position.set(3000, 1650);
            })
            .start();

        this.tileIndex = (this.tileIndex + 1) % 3;
    }

}
